import React from 'react';
import { Link } from 'react-router-dom';

import Constants from '../../config/constants';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../../components/datatable/RelationDataTable';
import EnvelopCreateModal from '../../modal/envelop/EnvelopCreateModal';
import { getColumnStyle, COLUMN_STYLE } from '../../components/datatable/util';

import {
  defaultRejectHandler,
  stringifyErrorMessage,
} from '../../utils/utility';

import {
  addEnvelopToZone,
  listEnvelop,
  removeEnvelopFromZone,
  searchEnvelopByText,
} from '../../redux/envelop/envelop_actions';


export class EnvelopDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      isShowCreateModal: false,
    };
  }

  getColumns() {
    const { zone, t } = this.props;
    const textColumn = getColumnStyle(COLUMN_STYLE.text);

    return [
      {
        id: 'envelop-name',
        Header: () => <b>{t('envelop')}</b>,
        Cell: row => <Link to={`/envelops/${row.value.id}/${row.value.type}`}>{row.value.name}</Link>,
        accessor: item => ({ name: item.name, id: item.id, type: item.type.toLowerCase() }),
        ...textColumn,
        entity: {
          list: (text, page) => searchEnvelopByText(text, zone.building_id, page, null)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        id: 'envelop-type',
        Header: () => <b>{t('type')}</b>,
        accessor: data => t(data.type.toLowerCase()),
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('azimuth angle')}</b>,
        accessor: 'azimuth_angle',
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('inclination')}</b>,
        accessor: 'inclination',
        ...getColumnStyle(COLUMN_STYLE.category),
      },
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listEnvelop(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  componentWillReceiveProps(nextProps) {
    if (
      (this.props.isEnvelopAddingToZone && !nextProps.isEnvelopAddingToZone && !nextProps.errorMessage) ||
      (this.props.isEnvelopRemovingFromZone && !nextProps.isEnvelopRemovingFromZone && !nextProps.errorMessage)
    ) {
      this.updateSortFilter(this.search.filtered, this.state.state, this.state.categoryOption);
    }
  }

  render() {
    const {
      isShowCreateModal,
    } = this.state;

    const {
      zone,
      envelopList,
      isEnvelopAddingToZone,
      isEnvelopRemovingFromZone,
      filteredCount,
      isLoading,
      errorMessage,
    } = this.props;

    const relationship = {
      create: ({ entityId }) => this.props.addEnvelopToZone(entityId),
      delete: id => this.props.removeEnvelopFromZone(id),
      isCreating: isEnvelopAddingToZone,
      isDeleting: isEnvelopRemovingFromZone,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <EnvelopCreateModal
          zone={zone}
          show={isShowCreateModal}
          onHide={() => this.setState({ isShowCreateModal: false })}
        />
        <RelationDataTable
          columns={this.getColumns()}
          relationship={relationship}
          data={envelopList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  envelopList: state.envelop.orderedIds.map(id => state.envelop.objects[id]),
  isLoading: state.envelop.isLoading,
  isEnvelopAddingToZone: state.envelop.isAddingToZone,
  isEnvelopRemovingFromZone: state.envelop.isRemovingFromZone,
  errorMessage: state.envelop.errorMessage,
});

const mapDispatchToProps = (dispatch, { zone }) => ({
  addEnvelopToZone: envelopId => dispatch(addEnvelopToZone(envelopId, zone.id)),
  removeEnvelopFromZone: id => dispatch(removeEnvelopFromZone(id)),
  listEnvelop: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listEnvelop(pageSize, page, sorted, filtered, isPublic, zone.building_id, zone.id)),
    ),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(EnvelopDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/EnvelopDataTable.js